import { lazy, Suspense } from "react";
import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SiteProvider } from "@/context/SiteContext";
import { CartProvider } from "@/context/CartContext";
import { POLICY_LINKS } from "@/data/copy";
import PublicLayout from "@/components/layout/PublicLayout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Conditions from "@/pages/Conditions";
import Services from "@/pages/Services";
import Faq from "@/pages/Faq";
import Contact from "@/pages/Contact";
import Shop from "@/pages/Shop";
import Product from "@/pages/Product";
import Checkout from "@/pages/Checkout";
import OrderConfirmation from "@/pages/OrderConfirmation";
import Policy from "@/pages/Policy";
import NotFound from "@/pages/NotFound";

const AdminRoot = lazy(() => import("@/pages/admin/AdminRoot"));
const AdminLogin = lazy(() => import("@/pages/admin/AdminLogin"));
const AdminLayout = lazy(() => import("@/pages/admin/AdminLayout"));
const AdminOverview = lazy(() => import("@/pages/admin/AdminOverview"));
const AdminOrders = lazy(() => import("@/pages/admin/AdminOrders"));
const AdminProducts = lazy(() => import("@/pages/admin/AdminProducts"));
const AdminProductEdit = lazy(() => import("@/pages/admin/AdminProductEdit"));
const AdminEnquiries = lazy(() => import("@/pages/admin/AdminEnquiries"));
const AdminSettings = lazy(() => import("@/pages/admin/AdminSettings"));
const AdminContent = lazy(() => import("@/pages/admin/AdminContent"));
const AdminAccount = lazy(() => import("@/pages/admin/AdminAccount"));

const Loading = () => <div className="flex min-h-[50vh] items-center justify-center text-slate-600">Loading…</div>;

function App() {
  return (
    <BrowserRouter>
      <SiteProvider>
        <CartProvider>
          <Toaster position="top-center" richColors />
          <Suspense fallback={<Loading />}>
            <Routes>
              <Route element={<PublicLayout />}>
                <Route index element={<Home />} />
                <Route path="about" element={<About />} />
                <Route path="conditions" element={<Conditions />} />
                <Route path="services" element={<Services />} />
                <Route path="faq" element={<Faq />} />
                <Route path="contact" element={<Contact />} />
                <Route path="shop" element={<Shop />} />
                <Route path="shop/:slug" element={<Product />} />
                <Route path="checkout" element={<Checkout />} />
                <Route path="order/:orderId" element={<OrderConfirmation />} />
                {POLICY_LINKS.map((p) => <Route key={p.slug} path={p.slug} element={<Policy slug={p.slug} />} />)}
                <Route path="*" element={<NotFound />} />
              </Route>
              <Route path="admin" element={<AdminRoot />}>
                <Route path="login" element={<AdminLogin />} />
                <Route element={<AdminLayout />}>
                  <Route index element={<AdminOverview />} />
                  <Route path="orders" element={<AdminOrders />} />
                  <Route path="products" element={<AdminProducts />} />
                  <Route path="products/new" element={<AdminProductEdit />} />
                  <Route path="products/:id" element={<AdminProductEdit />} />
                  <Route path="enquiries" element={<AdminEnquiries />} />
                  <Route path="settings" element={<AdminSettings />} />
                  <Route path="content" element={<AdminContent />} />
                  <Route path="account" element={<AdminAccount />} />
                </Route>
              </Route>
            </Routes>
          </Suspense>
        </CartProvider>
      </SiteProvider>
    </BrowserRouter>
  );
}

export default App;
